import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { resolutionPropType } from "app/utils/propTypes";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import { useLocation, useRouteMatch } from "react-router-dom";
import { checkSpecialOfferForSelectedDepartureDate } from "app/pages/Booking/Payment/paymentSelector";
import SpecialOffer from "app/pages/.shared/SpecialOffer/SpecialOffer";
import get from "lodash/get";

const SearchEngineMessagePlaceholderContainer = ({
	specialOffer,
	fallBackSpecialOffer,
	isSpecialOfferActive,
	resolution,
}) => {
	const location = useLocation();
	const match = useRouteMatch();

	let spo = undefined;

	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;
	if (!isMobile) {
		const isProductPage = match.path.includes(":productUri");
		const shouldDisplaySpecialOfferOnCurrentPage =
			isSpecialOfferActive &&
			(specialOffer.pages &&
				specialOffer.pages.find(page => {
					return (
						location.pathname.includes(page) || (page === "product" && isProductPage)
					);
				}));

		const shouldDisplaySpecialOfferFallbackOnCurrentPage =
			fallBackSpecialOffer.pages &&
			fallBackSpecialOffer.pages.find(page => {
				return location.pathname.includes(page) || (page === "product" && isProductPage);
			});

		if (shouldDisplaySpecialOfferOnCurrentPage) {
			spo = specialOffer;
		} else if (shouldDisplaySpecialOfferFallbackOnCurrentPage) {
			spo = fallBackSpecialOffer;
		}
	}

	// specialOffer.ui.background n'est pas passé à SpecialOffer pour ne pas avoir un block trop voyant ici
	return spo ? (
		<div className="booking-marketing-placeholder">
			<div className="search-engine-message-placeholder">
				<SpecialOffer
					type={spo.type}
					title={spo.title}
					message={spo.summary}
					titleColor={get(spo, "ui.titleColor")}
					pictoUrl={get(spo, "ui.pictoUrl")}
					tooltipMessage={spo.details}
				/>
			</div>
		</div>
	) : (
		<div className="booking-footer-placeholder" />
	);
};

SearchEngineMessagePlaceholderContainer.propTypes = {
	resolution: resolutionPropType,
	isSpecialOfferActive: PropTypes.bool,
	specialOffer: PropTypes.object,
	fallBackSpecialOffer: PropTypes.object,
};

SearchEngineMessagePlaceholderContainer.defaultProps = {
	specialOffer: {},
	fallBackSpecialOffer: {},
};

const mapStateToProps = state => {
	return {
		specialOffer: state.ficheProduit.specialOffer,
		fallBackSpecialOffer: state.partner.fallbackSpecialOffer,
		isSpecialOfferActive: checkSpecialOfferForSelectedDepartureDate(state),
		resolution: state.resolution,
	};
};

export default connect(mapStateToProps)(SearchEngineMessagePlaceholderContainer);
